import { esc } from "./utils.js";
import { navigate } from "./app.js";
import { rememberReturn } from "./returnTo.js";

/**
 * Log in and Sign up, on the pages open to visitors (the dive sites), that
 * bring them back to the same page afterwards (returnTo.js).
 *
 * Any element with `data-sign-in="login"` or `"register"` inside a root
 * passed to attachSignInLinks gets that behaviour, so a page can offer the
 * whole prompt or just a "Log in to post" button in place of Post.
 */
export function signInPromptHtml(text) {
  return `
    <div class="alert alert-light border d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
         id="sign-in-prompt">
      <div>${esc(text)}</div>
      <div class="d-flex gap-2">
        <a href="#/login" class="btn btn-sm btn-primary" data-sign-in="login">Log in</a>
        <a href="#/register" class="btn btn-sm btn-outline-primary" data-sign-in="register">Sign up</a>
      </div>
    </div>`;
}

/** The page being looked at, as a path returnTo.js accepts ("/dive-site/7"). */
function here() {
  return location.hash.replace(/^#/, "") || "/dive-sites";
}

/** root may be null (a page that showed no prompt). */
export function attachSignInLinks(root) {
  root?.querySelectorAll("[data-sign-in]").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      rememberReturn(here());
      navigate(`/${link.dataset.signIn}`);
    });
  });
}
